
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import Home from "./Home";
import Store from "./Store";
import Gallery from "./Gallery";
import Schedule from "./Schedule";
import TeamHistory from "./TeamHistory";
import Achievement from "./Achievement";
import Footer from "./layout/Footer";
import Navbar from "./layout/Navbar";
import { IMerchItem } from "../data";
import { activeMedia } from "../helpers";
import styles from "../assets/style.module.css";
import { CacheManager, Utils, resolveTemplateColors } from "../../../../utils";
import Definition from "../definition";
import { IMember, IProfileWebsite } from "../../../../services";
import { useComponentStyle } from "../../../../hooks/useComponentStyle";

export interface LandingProps {
    basePath: string;
    publicId: string;
    website: IProfileWebsite;
}

function Landing(props: LandingProps) {

    const location = ReactRouterDom.useLocation();
    const { website, basePath, publicId } = props;
    const [cart, setCart] = React.useState<IMerchItem[]>([]);
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const [profile, setProfile] = React.useState<IMember | undefined>(CacheManager.get(CacheManager.PROFILE_KEY) as IMember);
    const colors = resolveTemplateColors(Definition, website.design_settings?.scheme_settings?.colors, searchParams);
    useComponentStyle(`
        :root {
            --red: ${colors.danger};
            --green: ${colors.success};
            --muted: ${colors.text_muted};
            --text: ${colors.text};
            --text-light: ${colors.text_inverse};
            --paper: ${colors.background};
            --paper2: ${colors.background_alt};
            --grey: ${colors.background_muted};
            --ink: ${colors.surface_dark};
            --ink2: ${colors.surface_dark_alt};
            --accent: ${colors.primary};
            --accent-dark: ${colors.primary_dark};
            --header-bg: ${colors.header_background};
        }
    `);

    React.useEffect(() => {
        Utils.updateMeta({
            title: website.display_name,
            desc: website.profile_detail,
            logo: activeMedia(website, "LOGO")!,
        });
    }, [website]);

    React.useEffect(() => {
        window.scrollTo({ top: 0 });
    }, [location.pathname]);

    return (<>
        <Navbar website={website} basePath={basePath} profile={profile} cartCount={cart.length} onSignOut={() => setProfile(undefined)} />
        <main className={styles["page"]}>
            <ReactRouterDom.Routes>
                <ReactRouterDom.Route path="/merch" element={<Store website={website} onAddToCart={(item) => setCart((c) => [...c, item])} />} />
                <ReactRouterDom.Route path="/gallery" element={<Gallery website={website} />} />
                <ReactRouterDom.Route path="/team_history" element={<TeamHistory website={website} />} />
                <ReactRouterDom.Route path="/achievements" element={<Achievement website={website} />} />
                <ReactRouterDom.Route path="/achievement" element={<Achievement website={website} />} />
                <ReactRouterDom.Route path="/schedule" element={<Schedule website={website} publicId={publicId} />} />
                <ReactRouterDom.Route path="/" element={<Home website={website} basePath={basePath} publicId={publicId} />} />
            </ReactRouterDom.Routes>
        </main>
        <Footer website={website} basePath={basePath} profile={profile} />
    </>);
}

export default Landing;
